var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent29(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z",
    fill: "#bd2ba1",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z",
    opacity: 1,
    fill: "#fbc19e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbc19e",
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#690f03",
    opacity: 1,
    d: "M594.42+98.6537C594.42+98.6537+579.434+90.5366+592.546+69.9317C609.992+42.5173+673.044+16.5386+720.086+72.9434C731.476+86.5999+747.766+123.292+763.271+159.461C774.664+186.037+785.633+212.332+793.922+228.999C803.755+253.99+823.461+307.518+810.237+321.765C797.013+336.011+688.702+182.322+688.702+182.322L594.42+98.6537Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2ba1",
    d: "M566.782+89.3603L566.782+89.3603C572.788+82.6014+583.058+82.0716+589.721+88.1769L686.945+177.264C693.608+183.369+694.14+193.798+688.134+200.557L688.134+200.557C682.128+207.316+671.858+207.845+665.195+201.74L567.971+112.653C561.309+106.548+560.776+96.1191+566.782+89.3603Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.756+93.4576L518.244+93.4576C624.8+93.4576+702.439+171.874+702.439+275.139C702.439+275.139+638.751+234.447+580.059+208.427C553.299+196.564+497.26+189.292+447.063+207.217C374.74+233.044+330.927+281.134+330.927+281.134C330.927+177.87+399.2+93.4576+505.756+93.4576Z",
    opacity: 1,
    fill: "#690f03"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent29);
export default __webpack_public_path__ + "static/media/Student 29.05ba76e4fb1faed498abf65e83acf328.svg";
export { ForwardRef as ReactComponent };